import { JSEncrypt } from 'jsencrypt';
// import axios from "@/request/request";
import service from "@/utils/service";
/**
 * @description Rsa加密方式
 * @export
 * @class RsaEncryptUtils
 */
export default class RsaEncryptUtils {
	static async getPublicKey() {
		return new Promise((resolve, reject) => {
			service.get('/open/security/public-key').then(res => {
				if (res.status === 200) {
					sessionStorage.setItem('rsa-public-key', res.data);
					resolve(res.data);
				}
				resolve(res);
			}).catch(err => {
				console.log(err);
				reject(err)
			});
		});
	}

	static encode(publicKey, content) {
		var encrypt = new JSEncrypt()
		encrypt.setPublicKey(publicKey);
		return encrypt.encrypt(content);
	}
}